import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Menu, IconButton, Button, MenuItem, Typography, Tooltip } from '../../../../ui/core';
import { MoreVertIcon, WarningIcon } from '../../../../ui/icons';

import UserCard from '../UserCard';
import ActionCancel from './ActionCancel';
import ActionWhitelist from './ActionWhitelist';
import ActionBlacklist from './ActionBlacklist';
import UserCrispLink from '../../Users/UserCrispLink';

const TripDriverField = ({ trip, outboundTrip, excludedRiderIds }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [waiting, setWaiting] = useState(false);

  const noDriverOption = { id: 'unassigned', firstName: 'No driver attached' };
  const [value, setValue] = useState(trip.driver || noDriverOption);

  useEffect(() => {
    setValue(trip.driver || noDriverOption);
  }, [trip.driver]);

  const actions = [];
  if (trip.driver) {
    actions.push(
      <ActionCancel
        key="cancel"
        trip={trip}
        outboundTrip={outboundTrip}
        waiting={waiting}
        onWaitingChange={setWaiting}
        onClose={() => setAnchorEl(null)}
      />,
    );
  } else {
    actions.push(<ActionWhitelist key="whitelist" trip={trip} onClose={() => setAnchorEl(null)} />);
    actions.push(<ActionBlacklist key="blacklist" trip={trip} onClose={() => setAnchorEl(null)} />);
  }

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" gap="8px">
      {value.id !== 'unassigned' ? (
        <Button href={`/users/${value.id}`} target="_blank">
          <UserCard user={value} />
        </Button>
      ) : (
        <UserCard user={value} />
      )}
      {excludedRiderIds?.size > 0 && (
        <Tooltip title="Excluded pairing with a rider on this trip — see Rider-Driver Exclusions." arrow>
          <span style={{ display: 'inline-flex' }}>
            <WarningIcon sx={{ fontSize: 18, color: 'warning.main' }} />
          </span>
        </Tooltip>
      )}
      {actions.length > 0 && (
        <>
          <IconButton
            id="trip_drive_field_button"
            sx={{ marginLeft: '40px' }}
            aria-controls={open ? 'trip_drive_field_menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="trip_drive_field_menu"
            MenuListProps={{ sx: { minWidth: 268 }, component: 'div' }}
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
          >
            {actions}
          </Menu>
        </>
      )}
      {value.id !== 'unassigned' && <UserCrispLink userId={value.id} phoneNumber={value.phoneNumber} />}
    </Box>
  );
};

export default TripDriverField;
